import { AddRounded } from "@mui/icons-material";
import { nanoid } from "nanoid";
import { ChangeEvent, useContext, useState } from "react";
import styled from "styled-components";
import Modal from "../components/modal";
import PrimaryButton from "../components/primary-button";
import FirebaseContext from "../utils/firebase-context";

const Picker = styled.div`
	position: relative;
  height: 150px;
  min-width: 150px;
  cursor: pointer;
  border-radius: 12px;
  background: #EEEEEE;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #CCCCCC;
  font-size: 4rem;
  transition: .1s;
	margin-bottom: 1rem;
  &:hover {
    color: #BBBBBB;
  }
	img {
    height: 100%;
    width: 100%;
		object-fit: cover;
  }
`;

const Input = styled.input`
  display: none;
`;
const Label = styled.label`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  border-radius: 12px;
  cursor: pointer;
`;

function PreviewImage(props: { file: File }) {
	return <img src={URL.createObjectURL(props.file)} alt="Preview" />
}

export default function ChangeImageModal(props: {
	close: () => void;
	updateImage: (src: string) => void;
}) {
	const { updateImage } = props;
	const [img, setImg] = useState<File>();
	const [loading, setLoading] = useState(false);

	const firebase = useContext(FirebaseContext);

	const updateImagePicker = (e: ChangeEvent<HTMLInputElement>) => {
		const files = e.target.files;
		if (!files || !files[0]) return;
		setImg(files[0]);
	};

	const changeImage = async () => {
		const id = nanoid(12);
		if (!img) return;
		setLoading(true);
		const task = await firebase.storage.ref("blog_image/" + id).put(img);
		const src = await task.ref.getDownloadURL();
		updateImage(src);
		props.close();
	}

	return <Modal title="Bild ändern" close={props.close}>
		{loading ? <div>Änderungen werden vorgenommen...</div> : <>
			<div style={{
				display: "flex",
				alignItems: "center",
				justifyContent: "center"
			}}>
				<Picker>
					{!img ? <AddRounded /> : <PreviewImage file={img} />}
					<Input type="file" id={`file-input`} onChange={updateImagePicker} accept={"image/*"} />
					<Label htmlFor={`file-input`} />
				</Picker>
			</div>
			<PrimaryButton onClick={changeImage} disabled={!img}>
				Bild hochladen
			</PrimaryButton></>
		}
	</Modal>
}